import { useApolloClient } from '@apollo/client/react'
import { useScheduleData as useZionScheduleData } from '@fs/zion-rootstech'
import useCalendarConfig from './useCalendarConfig'
import useCalendarImageSizes from './useCalendarImageSizes'
import { useErrorHandlerOverlay } from '../../../hooks'

/**
 * App adapter over Zion's useScheduleData.
 *
 * Zion owns the multi-calendar fetch, the round-to-the-minute normalization, and the
 * dedupe/rebroadcast pass; this supplies the CAE Apollo client, the image sizes, and the
 * flag-resolved calendar config it takes as props.
 *
 * The overlay fires once here rather than once per calendar: Zion reports the first failure
 * from any calendar the flag left active, and a failed calendar clears its own rows, so
 * without this a failed fetch would look like a short schedule.
 */
export default function useScheduleData({ skip = false } = {}) {
  // The CAE client is the default Apollo client (see zion's ApolloProviders), so this is the
  // same client useLoggedQuery's useQuery resolved from context.
  const client = useApolloClient()
  const calendarConfig = useCalendarConfig()
  const imageSizes = useCalendarImageSizes()

  const { loading, data, error } = useZionScheduleData({ client, calendarConfig, imageSizes, skip })
  useErrorHandlerOverlay(error)

  return { loading, data, error }
}
